import { array, object, string } from 'yup';

import { RegexUtils } from '../regex-utils';

export const bankDetailsValidations = {
  accountPurpose: array()
    .of(
      object().shape({
        value: string().required('Please select bank account purpose'),
        label: string(),
      })
    )
    .min(1, 'Please select bank account purpose')
    .nullable()
    .required('Please select bank account purpose'),

  bankAccNumberOrBSN: object()
    .shape({
      value: string().required('Please select account type'),
      label: string(),
    })
    .nullable()
    .typeError('Please select account type')
    .required('Please select account type'),

  bankName: string()
    .required('Please enter bank name')
    .min(2, 'Character length not sufficient')
    .matches(RegexUtils.bankName, 'Please enter valid name')
    .max(100, 'Character length exceeded')
    .trim(),

  accountHolderName: string()
    .required('Please enter a name')
    .min(2, 'Character length not sufficient')
    .matches(RegexUtils.charsWithSpaceNoNumbersUTF8Regex, 'Please enter a valid name')
    .max(120, 'Character length exceeded')
    .trim(),

  accountNumber: string().when('bankAccNumberOrBSN.value', {
    is: (item: string, ix: string) => {
      return item === 'BANK' || ix === 'BANK';
    },
    then: () =>
      string()
        .required('Please enter account number')
        .min(8, 'Character length not sufficient')
        .matches(RegexUtils.numbersOnlyRegex, 'Account Number should contain numbers only')
        .max(8, 'Character length exceeded')
        .trim(),
    otherwise: () => string(),
  }),

  bsRollNumber: string().when('bankAccNumberOrBSN.value', {
    is: (item: string, ix: string) => item?.includes('BUILDING') || ix === 'BUILDING' || ix === 'BUILDING_SOCIETY',
    then: () =>
      string()
        .required('Please enter Building society number')
        .min(8, 'Character length not sufficient')
        .matches(RegexUtils.numbersOnlyRegex, 'Building society number should contain numbers only')
        .max(8, 'Character length exceeded')
        .trim(),
    otherwise: () => string(),
  }),

  sortCode: string()
    .nullable()
    .required('Please enter Sort Code')
    .test('is-valid-length', 'Character length not sufficient', (value) => {
      if (!value) return true;
      return value.length === 6;
    })
    .min(6, 'Character length not sufficient')
    .trim(),

  swift: string()
    .nullable()
    .test('is-valid-swift', 'Please enter a valid SWIFT code', (value) => {
      /**
       * Not required but if entered it will check for validity
       */
      if (!value) return true;
      return RegexUtils.swiftCodeRegex.test(value);
    })
    .test('is-valid-length', 'Please enter a valid SWIFT code', (value) => {
      if (!value) return true;
      return value.length === 8 || value.length === 11;
    })
    .max(8, 'Character length exceeded')
    .trim()
    .notRequired(),

  accountId: string().notRequired(),

  iban: string()
    .nullable()
    .notRequired()
    .test('is-valid-length', 'IBAN should have a minimum of 15-34 characters', (value) => {
      if (!value) return true; // return valid if the string is empty
      return value.length >= 15 && value.length <= 34;
    })
    .matches(RegexUtils.ibanRegex, "IBAN can't contain special characters")
    .max(34, 'Character length exceeded')
    .trim(),

  currency: object()
    .shape({
      code: string().required('Please select an Account Currency'),
      label: string(),
      phone: string(),
      currency: string().required('Please select an Account Currency'),
    })
    .required('Please select an Account Currency'),
};
